import { startsWith } from 'lodash';
import { map } from '@lendi-ui/breakpoint';
import { css } from 'styled-components';
import { createContext } from 'react';
import { track, Action, UserType } from '@lendi/lendi-analytics-package';

var AnalyticsContext = /*#__PURE__*/createContext({
  analyticsForNavigation: () => {}
});
var AnalyticsContextProvider = AnalyticsContext.Provider;

var trackNavigation = (text, isBroker, position, category, themeName) => {
  switch (themeName) {
    case 'LendiLogo':
      track({
        action: Action.navigate,
        button_text: text.toLowerCase(),
        category,
        position,
        user_type: isBroker ? UserType.broker : UserType.user
      });
      break;

    default:
      // @ts-ignore
      console.error('Not a Lendi Theme');
  }
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  line-height: 1.333;\n  white-space: normal;\n  border-spacing: 2px;\n  text-align: left;\n  word-spacing: normal;\n  letter-spacing: normal;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var display = val => map(val, v => v && "display: ".concat(v, ";"));
/**
 * Derive size from root CSS variable
 * @param multiplier
 */

var deriveSize = multiplier => {
  if (multiplier === 1) {
    return "var(--lendi-ui-size)";
  }

  return "calc(".concat(multiplier, " * var(--lendi-ui-size))");
};
var normalise = css(_templateObject());
var NORMALISE_LINE_HEIGHT = 1.333;

/**
 * return all the props of an object where the key begins with 'data-'
 * @param props The props object of a given component
 */
var getDataProps = props => {
  var dataProps = {};

  for (var _key in props) {
    if (startsWith(_key, 'data-')) {
      dataProps[_key] = props[_key];
    }
  }

  return dataProps;
};

export { AnalyticsContext, AnalyticsContextProvider, NORMALISE_LINE_HEIGHT, deriveSize, display, getDataProps, normalise, trackNavigation };
